.column {
    display: flex;
    flex-direction: column;
}

.columnWithGap {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
